import type { BatchRequest } from "./types";

/** Shared time-origin projection; neither wall rollback nor suspended monotonic time extends work. */
export function workDeadlineReached(request: BatchRequest): boolean {
  const deadline = request.deadline;
  if (!deadline) return false;
  const wall = Date.now();
  const monotonic = performance.timeOrigin + performance.now();
  return !Number.isFinite(deadline.wallAt) || !Number.isFinite(deadline.monotonicAt) ||
    !Number.isFinite(wall) || !Number.isFinite(monotonic) || wall >= deadline.wallAt || monotonic >= deadline.monotonicAt;
}
